import React from 'react';
import { Obstacle as StyledObstacle } from '../styles/StyledComponents';
import { Obstacle as ObstacleType } from '../hooks/useGame';

interface ObstacleProps {
  obstacle: ObstacleType;
}

const Obstacle: React.FC<ObstacleProps> = ({ obstacle }) => {
  return (
    <StyledObstacle 
      position={obstacle.position} 
      height={obstacle.height} 
    />
  );
};

export default Obstacle;
